import type { SiteMapPageContent } from './shipsticks.page.content'

// The Ship&Play brand renders ShipplaySiteMapPage, which sources its groups
// directly from `@/components/shipplay/siteLinks` rather than from
// `brand.pageContent.SiteMap`. This stub only exists so `brand.ts`'s
// per-brand PageContent map keeps a value for the SiteMap slot.
const content: SiteMapPageContent = { sections: [] }

export default content
